// extracted by mini-css-extract-plugin
export default {"progressContainer":"Progress_progressContainer__vocNq","circularProgress":"Progress_circularProgress__oZggy","progressText":"Progress_progressText__HWg53"};